import { Box, Image, LinkBox, LinkOverlay, Stack, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { ImageFallback } from '@/imports/ui/chakra/components/ImageFallback';

import { getFirstString, getHighlightValue } from '../hitHelpers';
import { OpenSearchHit } from '../types';
import { OpenSearchText } from './OpenSearchText';

export const OpenSearchOrganization: React.FC<{ hit: OpenSearchHit }> = ({
  hit,
}) => {
  const organizationId = getFirstString(hit.sourceId, hit.objectID);

  return (
    <LinkBox
      as={Stack}
      direction="row"
      spacing="2"
      alignItems="center"
      p="2"
      bg="white"
      _hover={{ bg: 'gray.100' }}
      borderRadius="xl"
      cursor="pointer"
    >
      <Image
        boxSize="8"
        objectFit="cover"
        src={getFirstString(hit.profilePictureUrl) || undefined}
        alt=""
        borderRadius="base"
        fallback={<ImageFallback boxSize="8" borderRadius="base" />}
      />

      <Box>
        <LinkOverlay as={NextLink} href={`/companies/${organizationId}`}>
          <Text noOfLines={1} textStyle="bodyStrong">
            <OpenSearchText
              value={
                getHighlightValue(hit, 'name', '_highlightResult') ||
                'Organization'
              }
            />
          </Text>
        </LinkOverlay>

        <Text noOfLines={1} textStyle="compact" color="gray.600">
          <OpenSearchText
            value={getHighlightValue(hit, 'aboutUs', '_snippetResult')}
          />
        </Text>
      </Box>
    </LinkBox>
  );
};
